import React, { useState, useEffect } from 'react'; 
import { useAuth } from '../utils/AuthContext/AuthContext';
import { useParams } from 'react-router-dom';
import config from '../utils/config'
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';

// ASSETS
import CompletedSVG from "../assets/Completed";
import SignatureSVG from "../assets/Signature";
import HomeLoadSVG from '../assets/HomeLoad';
import AvatarSVG from '../assets/Avatar';
import PeopleSVG from '../assets/People';
import InfoModal from '../components/InfoModal';
import CalendarSVG from '../assets/Calendar';

function AmendFinal() {
    const [packetDetails, setPacketDetails] = useState(null);
    const [amendmentData, setNewAmendmentData] = useState(null);
    const { amendmentId } = useParams();
    const { token, user } = useAuth();
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [isVoided, setIsVoided] = useState(false);
    const navigate = useNavigate();
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    function formatTitle(title) {
        return title
            .replace(/_/g, ' ')
            .split(' ')
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')
            .replace(/ Deadline$/, '');  // Remove " Deadline" from the end of the title
    }

    function formatDate(dateString) {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const date = new Date(dateString);
        const utcDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
        return utcDate.toLocaleDateString(undefined, options);
    }

    const navigateToAmendForm = () => {
      navigate('/amendextend');
    };

useEffect(() => {
    setIsLoading(true);
    // fetch(`http://localhost:5000/api/amendmentdata/${amendmentId}`, {
      fetch(`${config.apiBaseUrl}/amendmentdata/${amendmentId}`, {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(data => {
        setPacketDetails(data?.packetDetails);
        setNewAmendmentData(data) 
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .catch(e => {
        setError(e.toString());
        setIsLoading(false);
    });
  }, [amendmentId, token]);

  // console.log("Amendment Data:", amendmentData);
  // console.log("Amendment Id:", amendmentId);

  let status, statusClasses, remainingSigners;
  // console.log("New PacketDetails:", packetDetails);

  if (packetDetails) {
    status = packetDetails.status;
    remainingSigners = packetDetails.numberRemainingSigners;

    if (status === 'completed') {
        
        statusClasses = "bg-green-100 text-green-600 rounded-xl text-center p-1";
    } else if (status === 'draft' || isVoided) {
      statusClasses = "bg-slate-100 text-slate-700 rounded-xl text-center p-1";
  } else {
        statusClasses = "bg-blue-100 text-blue-700 rounded-xl text-center p-1";
    }
}

if (packetDetails && packetDetails.documentGroup && packetDetails.documentGroup.signers) {
  const lastCompletedRoutingOrder = packetDetails.documentGroup.signers.reduce((maxOrder, signer) => {
    return (signer && signer.status === 'completed') ? Math.max(maxOrder, signer.routingOrder) : maxOrder;
  }, 0);

  packetDetails.documentGroup.signers = packetDetails.documentGroup.signers.map((signer, index) => {
    let statusText;
    if (signer && signer.status === 'completed') {
      statusText = 'Signed';
    } else if (signer && signer.status === 'viewed') {
      statusText = 'Viewed';
    } 
    else if (signer && signer.routingOrder === lastCompletedRoutingOrder + 1) {
      statusText = 'Awaiting Signature';
    } else {
      statusText = 'Awaiting Email After Signer Above Signs';
    }
    return { ...signer, statusText }; // return the signer object with the statusText
  })
}

  return (
    <>
    {isLoading ? (
      <div className='flex justify-center items-center w-full h-full'>
        <div className='flex flex-col jusitfy-center'>
          {isMobile ? <HomeLoadSVG width={100} height={100}/> : <HomeLoadSVG width={200} height={200}/>}
          <h1 className='text-2xl items-center'>Gathering Contract Info</h1>
        </div>
      </div>
    ) : (
    <div className="items-center w-[375px] md:w-[1100px]">
      <div className='w-full mb-5 md:mb-10'>
      <h1 className="text-black text-[20px] md:text-4xl font-light">
        {amendmentData && amendmentData.address ? (
          `${amendmentData.address.street}, ${amendmentData.address.city}, ${amendmentData.address.state} ${amendmentData.address.zip}`
        ) : ''}
      </h1>
          <div className='inline-flex items-center'>
            {isMobile ? <CalendarSVG width={18} height={18}/> : <CalendarSVG width={25} height={25}/> }
            <div className='flex flex-col mt-5 ml-2'>
              <p className='text-sm text-slate-600'>Amendment Date</p>
              <p className='text-slate-600 text-lg'>{formatDate(amendmentData?.amendmentDate)}</p>
            </div>
          </div>
      </div>
      <div className={`${isMobile ? 'flex flex-col gap-6' : 'inline-flex'} items-start justify-between w-full`}>
        <div className="w-[375px] md:w-[450px] max-h-[675px] p-5 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] overflow-y-auto">
            <div className='flex-col'> 
            <h1 className='text-[18px] md:text-2xl font-semibold mb-4'>Changed Dates</h1>
            {amendmentData?.newDates && Object.entries(amendmentData.newDates).filter(([key, value]) => value.isChanged).map(([key, newValue]) => {
                // Find the current date using the same key in amendmentData.currentDates
                const currentDate = amendmentData.currentDates?.[key]?.date;
                return (
                <div key={key} className='mb-6'>
                    <h2 className="text-black text-[14px] md:text-lg mb-2">{formatTitle(key)}</h2>
                    <div className='inline-flex w-full gap-10'>
                    <div className='flex flex-col'>
                        <p className='text-slate-600 text-sm'>Previous Date:</p>
                        {currentDate && <p>{currentDate}</p>}
                    </div>
                    <div className='flex flex-col'>
                        <p className='text-slate-600 text-sm'>New Date:</p>
                        <p>{newValue?.date}</p>
                    </div>
                    </div>    
                </div>
                );
            })}
            <hr className='border border-slate-200 my-5'/>

            <h1 className='text-[18px] md:text-2xl font-semibold mb-4'>Deleted Dates</h1>
            {amendmentData?.newDates && Object.entries(amendmentData.newDates).filter(([key, value]) => value.isDeleted).map(([key, newValue]) => {
                // Find the current date using the same key in amendmentData.currentDates
                const currentDate = amendmentData.currentDates?.[key]?.date;
                return (
                <div key={key} className='mb-6'>
                    <h2 className="text-black text-lg mb-2">{formatTitle(key)}</h2>
                    <div className='flex flex-col'>
                    {/* <p className='text-slate-600 text-sm'>Previous Date:</p>
                    {currentDate && <p>{currentDate}</p>} */}
                    </div>
                </div>
                );
            })}
            </div>
        </div>
        <div className="w-[375px] md:w-[650px] md:mx-5 p-5 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px] max-h-[675px] overflow-y-auto">
          <div className='inline-flex w-full justify-between mb-5'>
            <h1 className='text-[18px] md:text-2xl font-semibold'>Contract Details</h1>
            <div className={`w-auto p-1 px-3 inline-flex items-center text-sm font-[Inter] justify-center ${statusClasses}`}>{status === "completed" ? "Completed" : status === 'draft' || isVoided ? 'Voided' : "In Progress"}</div>
          </div>
          {(packetDetails || amendmentData) && (
            <div>
              {
                packetDetails?.documentGroup && packetDetails?.documentGroup?.signers && packetDetails?.documentGroup?.signers?.map((signer, index) => {
                  return (
                    <div key={index} className="flex-col items-center justify-start gap-2">
                      <div className='inline-flex items-center'>
                        {signer.status === 'completed' && <CompletedSVG/>}
                        {signer.status === 'sent' && <SignatureSVG />}
                        {signer.status === 'viewed' && '👀'}
                        <h1 className="pl-2 pr-2 font-bold text-shi-deep-purple">{signer.name}</h1>
                        <span className='pr-2'>&bull;</span>
                        <span>
                          {signer.statusText} 
                        </span>
                      </div>
                      <div className="inline-flex justify-start w-[750px] ml-11">
                        <span className="mb-3 pr-4">#{signer.routingOrder} Signer</span>
                        <span>{signer.email}</span>
                      </div>
                    </div>
                  );
                })
              }
            </div>
            )}
        </div>

        <div className="flex flex-col items-start w-[375px] md:w-[275px] max-h-[675px] overflow-y-auto p-5 bg-white rounded-lg shadow-[rgba(0,0,0,.5)_-2px_2px_10px_-5px]">
          <h1 className='font-semibold text-[18px] md:text-2xl mb-5'>Manage Contract</h1>
          
          <div className='flex flex-col gap-2'>

               <div className="items-center">
                 <button 
                   className={`text-[17px] font-['Inter'] p-1.5 ${'text-black'}`}
                 >
                   <a href={`${packetDetails?.documentGroup?.files?.[0]?.downloadURL}`} >Download Contract</a>
                 </button>
               </div>

          {/* <div className="items-center">
            <button 
              className={`text-[17px] font-['Inter'] p-1.5 ${!(packetDetails?.eid && packetDetails?.documentGroup?.status === 'partial' && !isVoided) ? 'text-gray-300' : 'text-black'}`}
              onClick={() => {
                setModalContent('Are you sure you want to void this contract?');
                setHandleModalConfirm(() => handleVoidClick);
                setHandleModalCancel(() => setShowModal(false));
                }
              }
              disabled={!(packetDetails?.eid && packetDetails?.documentGroup?.status === 'partial' && !isVoided)}
            >
              Void Contract
            </button>
          </div> */}

          <div className="items-center">
            <button 
              // className={`text-lg font-Inter p-1.5 ${(packetDetails?.eid) ? 'text-gray-300' : 'text-shi-green'}`}
              className={`text-[17px] font-Inter text-black p-1.5 ${'text-black'}`}
              onClick={navigateToAmendForm}  
            >
              Create New Amendment
            </button>
          </div>
          
          {/* <div className="items-center">
            <button 
              className={`text-[17px] font-['Inter'] p-1.5 ${(packetDetails?.eid && packetDetails?.status !== 'completed' || isVoided) ? 'text-black' : 'text-gray-300'}`}
              // onClick={navigateToFormData}  
              disabled={!(packetDetails?.eid && packetDetails?.status === 'draft')} 
            >
              Resend to Next Signer
            </button>
          </div> */}

      </div>
  </div>
</div>
      
        {/* <InfoModal 
          isOpen={showModal} 
          onClose={handleCloseModal} 
          content={modalContent} 
          onConfirm={handleModalConfirm} 
          onCancel={handleModalCancel}
        >
          <div>
              <p>{modalContent}</p>
              <div className='w-full mt-3 inline-flex gap-20 justify-center items-center'>
                  <button 
                      className='border border-red-600 rounded-md p-1.5 w-[80px] hover:bg-slate-200' 
                      onClick={handleModalConfirm}
                      >Yes</button>
                  <button 
                      className='border border-black rounded-md p-1.5 w-[80px] hover:bg-slate-200' 
                      onClick={() => setShowModal(false)}
                  >No</button>
              </div>
          </div>
        </InfoModal> */}
      </div>
    )}
    </>
  )
}

export default AmendFinal;